import { Component, OnInit } from '@angular/core';
import { DbService } from '../../services/db.service';

import { from, Observable, Subscription, BehaviorSubject, Subject, forkJoin, of } from 'rxjs';
import { map, mergeMap, concatMap, reduce, catchError, tap, takeUntil,  } from 'rxjs/operators';
import { RootStoreState, SystemActions } from '../../root-store';
import { Store } from '@ngrx/store';
import { StepActions } from '../../root-store/step';
import { StationAction } from '../../root-store/station';
import { ApiService } from 'src/app/services/api.service';

/**
 * Display started operation, finished operation, uploaded operation
 *
 * @export
 * @class DashboardComponent
 * @implements {OnInit}
 */
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {
  pendingOperations: Array<any> = [];
  authState: Observable<any>;
  updaterSubscription: Subscription;
  allOperations$: Observable<any>;
  destroy$ = new Subject<void>();

  
  displayedColumns: string[] = [
    'date_start',
    'operation_type',
    'id_rete',
    'nome',
    'username',
    'notification_open_status',
    'data',
    'forFetch',
    'controls'
  ];
  
  hideUploaded: Boolean = true;
  loading: Boolean = false;

  constructor(
    private db: DbService,
    private api: ApiService,
    private store: Store<RootStoreState.State>) {}


  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngOnInit() {
    this.drawTable();

    // Reset State Step
    this.store.dispatch(new StepActions.ResetState());

    // Reset State Station
    this.store.dispatch(new StationAction.ResetData());

    this.authState = this.store.select('auth');

    // Updater DB
    this.updaterSubscription = this.db.onDbUpdate().pipe(takeUntil(this.destroy$)).subscribe(() => this.drawTable());
  }

  genereteUniqueKeyOperation(operation: any): string {
    let keyoperation;
    try {
      keyoperation = `${operation.date_index}-${operation.id_cliente}-${operation.id_stazione}-${operation.operation_type}`;
    } catch (error) {
      keyoperation = Math.floor(10000000 + Math.random() * 90000000).toString();
    }

    return keyoperation;
  }

  getOperationsWithPendingStatus$(): Observable<any[]> {
    const operations$ = from(this.db.getTableData('smart-pga', 'app_operation'));
    const pendingOps$ = from(this.db.getTableData('smart-pga', 'app_pending_operation'));
  
    return forkJoin([operations$, pendingOps$]).pipe(
      map(([operations, pendingOps]) => {
        // Set di chiavi uniche delle pending (più efficiente di includes su array)
        const keysPendingOps = new Set(
          pendingOps.map(op => this.genereteUniqueKeyOperation(op))
        );
  
        // Trasformo tutte le operations aggiungendo il flag forFetch
        const enrichedOps = operations.map(op => ({
          ...op,
          forFetch: keysPendingOps.has(this.genereteUniqueKeyOperation(op))
        }));
  
        // Ordino: prima le pending, poi le altre; all'interno ordino per data decrescente
        return enrichedOps.sort((a, b) => {
          // Prima i pending
          if (a.forFetch && !b.forFetch) return -1;
          if (!a.forFetch && b.forFetch) return 1;
  
          // Poi per data_start (dal più grande al più piccolo)
          return new Date(b.date_start).getTime() - new Date(a.date_start).getTime();
        });
      })
    );
  }


  drawTable() {
    this.loading = true;
  
    this.allOperations$ = this.getOperationsWithPendingStatus$().pipe(
      tap(() => (this.loading = false)),
      catchError(err => {
        this.loading = false;
        const errMsg = `Dashboard.component.ts: ${err.toString()}`;
        console.error(err);
        return this.api.sendError(errMsg);
      })
    );
  }


  uploadPendingOperation() {
    this.store.dispatch(new SystemActions.TryUploadPendingOperations());
    this.store.dispatch(new SystemActions.TryUploadSavedFiles());
    this.drawTable();
  }
}
